<div class="user-avatar-wrapper" [class.status-on]="status === 'on'" [class.status-off]="status === 'off'"
    [style.width]="getAvatarSize()" [style.height]="getAvatarSize()">
    <div class="user-avatar" [class.has-image]="hasCustomAvatar()" [class.fill]="fill" [style.width]="getAvatarSize()"
        [style.height]="getAvatarSize()">

        @if (hasCustomAvatar()) {
        <img [src]="avatarUrl" [alt]="fullName || firstName + ' ' + lastName" class="avatar-image" />
        } @else {
        <div class="avatar-initials" [style.background-color]="getBackgroundColor()" [style.font-size]="getFontSize()">
            {{ getInitials() }}
        </div>
        }

        @if (showStatus) {
        <div class="status-indicator" [class.online]="isOnline" [class.offline]="!isOnline">
        </div>
        }
    </div>

    @if (icon) {
    <mat-icon class="avatar-badge">{{ icon }}</mat-icon>
    }

    <!-- Overlay de chargement -->
    @if (isLoading()) {
    <div class="upload-overlay">
        <div class="spinner"></div>
        <p class="progress-text">{{ loading }}%</p>
    </div>
    }
</div>